import classNames from 'classnames';
import { forwardRef, type HTMLAttributes, memo } from 'react';

export type TableRowProps = {
  className?: string;
} & HTMLAttributes<HTMLDivElement>;

export const TableRow = memo(
  forwardRef<HTMLDivElement, TableRowProps>(({ className, ...props }, ref) => (
    <div
      // biome-ignore lint/a11y/noNoninteractiveTabindex: the row div takes focus so keyboard selection can land on it
      tabIndex={0}
      className={classNames('tableRow flex items-center ads:text-metadata text-14 text-gray-10', className)}
      ref={ref}
      {...props}
    />
  )),
);

TableRow.displayName = 'TableRow';
